import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
const sizeClass = {
    sm: 'h-8 w-8 text-[11px]',
    md: 'h-[38px] w-[38px] text-[12.5px]',
    lg: 'h-11 w-11 text-[14px]',
};
/**
 * Gradient avatar in the Chaosology house style.
 *
 * Renders an <img> when `src` is provided; otherwise draws a royal→sky
 * gradient tile with the user's initials (mirrors `.avatar` in the mockup).
 * Always carries an accessible label — screen readers never get a silent
 * avatar (spec §9.1, §10).
 */
export function Avatar({ initials, src, size = 'md', className, alt }) {
    const common = clsx('inline-grid place-items-center rounded-full font-semibold text-white select-none tracking-[0.02em]', sizeClass[size], className);
    if (src) {
        return (_jsx("img", { src: src, alt: alt ?? initials, className: clsx(common, 'object-cover'), style: {
                boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.35), 0 0 0 2px var(--glass-bg-strong), 0 6px 16px -4px rgba(91,63,228,0.45)',
            } }));
    }
    return (_jsx("span", { className: clsx(common, 'cursor-pointer'), role: "img", "aria-label": alt ?? initials, style: {
            background: 'linear-gradient(135deg, var(--royal-hi), var(--sky-glow))',
            boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.35), 0 0 0 2px var(--glass-bg-strong), 0 6px 16px -4px rgba(91,63,228,0.45)',
        }, children: initials }));
}
